import React, { useState } from 'react';
import api from '../services/api';
import './SharkManagement.css';
import './Button.css';

function EditShark() {
    const [sharkId, setSharkId] = useState('');
    const [round, setRound] = useState(1);
    const [dbId, setDbId] = useState(null);
    const [weightLbs, setWeightLbs] = useState('');
    const [weightOz, setWeightOz] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [isLookingUp, setIsLookingUp] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const handleLookup = async (e) => {
        e.preventDefault();
        setIsLookingUp(true);
        setMessage('');
        setDbId(null);
        setWeightLbs('');
        setWeightOz('');
        try {
            const response = await api.get(`/sharks/by_shark_id/${sharkId.trim()}?round=${round}`);
            const shark = response.data;
            setDbId(shark.id);
            setWeightLbs(shark.weight_lbs);
            setWeightOz(shark.weight_oz);
            setMessage(`Found: ${shark.shark_id} — Round ${shark.round} — ${shark.weight_lbs} lbs ${shark.weight_oz} oz`);
            setMessageType('success');
        } catch {
            setMessage(`Shark "${sharkId.trim()}" not found in Round ${round}.`);
            setMessageType('error');
        } finally {
            setIsLookingUp(false);
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!dbId) return;
        setIsUpdating(true);
        setMessage('');
        try {
            await api.put(`/sharks/${dbId}`, {
                shark_id: sharkId.trim(),
                weight_lbs: parseInt(weightLbs, 10),
                weight_oz: parseInt(weightOz, 10) || 0,
                round: parseInt(round, 10),
            });
            setMessage('Shark updated successfully.');
            setMessageType('success');
        } catch (error) {
            const detail = error.response?.data?.detail || 'Failed to update shark.';
            setMessage(detail);
            setMessageType('error');
        } finally {
            setIsUpdating(false);
        }
    };

    const handleRoundOrIdChange = () => {
        setDbId(null);
        setWeightLbs('');
        setWeightOz('');
        setMessage('');
    };

    return (
        <div className="shark-mgmt-container">
            <h2>Edit Shark</h2>

            <form className="shark-mgmt-form" onSubmit={handleLookup}>
                <h3>Look Up Shark</h3>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="shark-id">Shark ID</label>
                        <input
                            id="shark-id"
                            type="text"
                            value={sharkId}
                            onChange={(e) => { setSharkId(e.target.value); handleRoundOrIdChange(); }}
                            placeholder="e.g. F001"
                            required
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="round">Round</label>
                        <select
                            id="round"
                            value={round}
                            onChange={(e) => { setRound(Number(e.target.value)); handleRoundOrIdChange(); }}
                        >
                            <option value={1}>Round 1</option>
                            <option value={2}>Round 2</option>
                            <option value={3}>Round 3</option>
                        </select>
                    </div>
                </div>
                <button className="btn btn-secondary" type="submit" disabled={isLookingUp}>
                    {isLookingUp ? 'Looking up...' : 'Find Shark'}
                </button>
            </form>

            {dbId && (
                <form className="shark-mgmt-form" onSubmit={handleUpdate}>
                    <h3>Update Weight</h3>
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="weight-lbs">Weight (lbs)</label>
                            <input
                                id="weight-lbs"
                                type="number"
                                min="0"
                                value={weightLbs}
                                onChange={(e) => setWeightLbs(e.target.value)}
                                required
                                autoFocus
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="weight-oz">Weight (oz)</label>
                            <input
                                id="weight-oz"
                                type="number"
                                min="0"
                                max="15"
                                value={weightOz}
                                onChange={(e) => setWeightOz(e.target.value)}
                            />
                        </div>
                    </div>
                    <button className="btn btn-primary" type="submit" disabled={isUpdating}>
                        {isUpdating ? 'Updating...' : 'Save Changes'}
                    </button>
                </form>
            )}

            {message && <p className={`message ${messageType}`}>{message}</p>}
        </div>
    );
}

export default EditShark;
